import type { ComponentType, ReactNode } from 'react';
import { MdInbox } from 'react-icons/md';

interface IconProps {
  size?: number | string;
  className?: string;
}

interface Props {
  icon?: ComponentType<IconProps>;
  title: string;
  message?: string;
  action?: ReactNode;
}

export function PageEmpty({ icon: Icon = MdInbox, title, message, action }: Props) {
  return (
    <div className="flex h-full w-full items-center justify-center p-10">
      <div className="flex max-w-sm flex-col items-center text-center animate-fade-in">
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/[0.08] text-primary ring-1 ring-primary/15">
          <Icon size={26} />
        </div>
        <h3 className="text-[18px] font-semibold tracking-tight text-foreground">
          {title}
        </h3>
        {message && (
          <p className="mt-1.5 text-[13.5px] leading-relaxed text-foreground-muted">
            {message}
          </p>
        )}
        {action && <div className="mt-5">{action}</div>}
      </div>
    </div>
  );
}
